import { Injectable } from '@angular/core';
import { BarcodeFormat, BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { ToastColor, ToastDuration, ToastService } from '@services/toast/toast.service';
import { UnitActivityProxyService } from '@services/unit-activity-proxy/unit-activity-proxy.service';

@Injectable({
  providedIn: 'root'
})
export class JoinUnitWithQRCodeService {
  constructor(private unitActivityProxy: UnitActivityProxyService, private toastService: ToastService) {}

  joinUnit() {
    BarcodeScanner.isSupported().then(result => {
      if (result.supported) {
        BarcodeScanner.scan({ formats: [BarcodeFormat.QrCode] })
          .then(result => {
            if (result.barcodes.length == 1) {
              const resourceName: string = result.barcodes[0].displayValue;
              this.unitActivityProxy
                .joinUnitActivity(resourceName)
                .toPromise()
                .then(result => {
                  if (!result) {
                    this.toastService.show('Mobile.JoinUnitError', ToastColor.Error, undefined, ToastDuration.Long);
                  }
                });
            }
          })
          .catch(error => console.log(error));
      }
    });
  }
}
